import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import fullCreationMetadata from "@irati/core-meta/services/fragments/businessCreation"
import fullUser from "../fragments/fullUserV4"
import fullTeam from "../fragments/fullTeamV4"
import fullBusiness from "../fragments/fullBusiness"

const query = gql`
  mutation UpdateBussiness($data: UpdateBusinessInput!, $withAdmins: Boolean!, $withRootTeam: Boolean!, $withCreationMeta: Boolean!) {
    updateBusiness(data: $data) {
      ...fullBusiness
      globalAdmins @include(if: $withAdmins) {
        ...fullUser
      }
      rootTeam @include(if: $withRootTeam) {
        ...fullTeam
      }
      creationMetadata @include(if: $withCreationMeta) {
        ...fullCreationMetadata
      }
    }
  }
  ${fullTeam}
  ${fullBusiness}
  ${fullUser}
  ${fullCreationMetadata}
`

export const businessUpdateKey = getQueryNames(query)[0]

export default query
